module.exports = {"id":"200138","name":"Michael Hector","rating":"71","photo":"./data/images/photos/0/200138.png","club":{"name":"Hull City","logo":"./data/images/clubs/HullCity.png"},"positions":["DC","MDC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MichaelHector0.json
// module id = 2985
// module chunks = 0